<template>
  <PopUp
    :pop-up-active="popupActive"
    @click="$_popupClose()"
  >
    <div class="popup-title">
      <p class="title">
        <WsText001
          h3
          bold
        >
          <i :class="titleIcon" />
          {{ popupTitle }}
        </WsText001>
      </p>
    </div>
    <div class="popup-content">
      <WsText001 h5>
        {{ popupContent }}
      </WsText001>
      <LvImgList
        v-if="_images && _images.length"
        :marginTop="15"
        :imageList="_images"
        @go-to="$_onGoToFile($event)"
      />
      <LvFileList
        v-if="_attaches && _attaches.length"
        twoItem
        title="附件"
        nonBorderTop
        :marginTop="20"
        :value="_attaches"
        @go-to="$_onGoToFile($event)"
      />
    </div>
  </PopUp>
</template>
<script>
import H_file from '@/helpers/file';

export default {
  name: "LlNormalPopup",
  props: {
    titleIcon: {
      type: String,
      default: "",
    },
    popupTitle: {
      type: String,
      default: "",
    },
    popupContent: {
      type: String,
      default: "",
    },
    popupActive: {
      type: Boolean,
      default: false,
    },
    attaches: {
      type: Array,
    },
    images: {
      type: Array,
    },
    tempAttaches: {
      type: Array,
    },
    tempImages: {
      type: Array,
    }
  },
  computed: {
    _images() {
      let _images = [];
      if (this.images) _images = [..._images, ...this.images];
      if (this.tempImages) _images = [..._images, ...this.tempImages];
      return _images;
    },
    _attaches() {
      let _attaches = [];
      if (this.attaches) _attaches = [..._attaches, ...this.attaches];
      if (this.tempAttaches) _attaches = [..._attaches, ...this.tempAttaches];
      return _attaches;
    },
  },
  methods: {
    $_popupClose() {
      this.$emit("popup-close");
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/popup";
</style>